<span class="dialog-container">
    <span class="relative flex flex-col w-full h-full p-8 !pb-4">
        <div class="p-0" mat-dialog-content>
            <ng-container>
                <div class="absolute top-0 right-0 pt-4 pr-4">
                    <button (click)="close()" mat-icon-button>
                        <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                    </button>
                </div>
            </ng-container>

            <ng-container>
                <div class="sm:flex xs:block w-100 border-b pb-2 mb-2 items-center">
                    <div class="sm:flex-initial xs:block xs:max-w-100 sm:max-w-70pr">
                        <div class="text-2xl font-bold truncate basic-fuse-gray-color">
                            {{ (data && data.title) || ('label_information' | translate) }}
                        </div>
                    </div>
                </div>

                <div class="float-left w-full mt-2 mb-4">
                    <p class="whitespace-pre-line">{{ data && data.message }}</p>
                </div>
            </ng-container>
        </div>
    </span>

    <span class="relative flex flex-col w-full h-full !pb-3 !pt-2 !pr-6 bg-slate-50">
        <div mat-dialog-actions>
            <button class="float-right" mat-flat-button [mat-dialog-close]="true" color="primary" cdkFocusInitial>
                {{ (data && data.okLabel) || ('label_ok' | translate) }}
            </button>
        </div>
    </span>
</span>
